'use client'

export function NewRelicSourceMapTest() {
  return (
    <button
      className='border-0 bg-transparent text-transparent'
      onClick={() => {
        throw new Error('NEW_RELIC_SOURCEMAP_TEST_HAFIZALQURAN')
      }}
    >
      Test New Relic Source Map
    </button>
  )
}
